<div class="sticky" id="agent-nav-bar">
  @if (nav.showNav) {
    <nav class="navbar navbar-expand-md navbar-dark bg-dark-blue navbar-expand navbar-expand-sm navbar-expand-xs">
      <div id="brand" [class.cus-d-none]="showSearchPopup === true">
        <a
          class="navbar-brand cursor-pointer"
          [routerLink]="['/company', authService.companyUrlName]"
          (click)="backToDashboard()">
          <img src="/assets/img/logo-nav.png" [alt]="version" />
        </a>
      </div>
      <div class="navbar-collapse" id="main-nav">
        <div class="d-md-flex w-100 d-sm-flex d-xs-flex d-flex">
          <app-search-bar class="w-100" />
          <!--Notification start-->
          @if (authService.loggedIn) {
            <div class="right-nav-wrap flex-shrink-1" [class.cus-d-none]="showSearchPopup === true">
              <ul class="navbar-nav ml-auto">
                @if (authService.hasUserRole) {
                  <li class="nav-item dropdown mx-2 notification-icon-respo mb-m mb-notification">
                    <app-agent-notifications-dropdown />
                  </li>
                }
                <li
                  ngbDropdown
                  #userMenu="ngbDropdown"
                  placement="bottom-end top-end"
                  class="nav-item dropdown text-nowrap upanel-dropdown-handler login-mb">
                  <a
                    aria-haspopup="true"
                    ngbDropdownToggle
                    appKeyboardClickable
                    class="nav-link no-caret"
                    id="upanel-dropdown-trigger"
                    role="button">
                    <span class="nav-user-wrap clearfix">
                      @if (isLoggedInUserImage) {
                        <span
                          class="customer-avatar avatar avatar-sm"
                          style="background-size: cover; background-position: center; background-repeat: no-repeat"
                          [style.background-image]="'url(' + loggedInUserAvatarUrl + ')'"></span>
                      }
                      @if (!isLoggedInUserImage) {
                        <span class="customer-avatar avatar avatar-teal avatar-sm">
                          <span>{{ loggedInUserInitials }}</span>
                        </span>
                      }
                      <span class="nav-user-name-wrap d-none d-xl-inline-block">
                        <span class="nav-user-name">{{ loggedInUserFullName }}</span>
                        <span class="nav-user-company">{{ authService.companyName }}</span>
                      </span>
                      <i class="material-icons"> keyboard_arrow_down </i>
                    </span>
                  </a>
                  <div
                    ngbDropdownMenu
                    id="upanel-dropdown"
                    class="dropdown-menu dropdown-menu-right shadow"
                    aria-labelledby="upanel-dropdown-trigger">
                    <app-user-company-selector />
                    <a ngbDropdownItem class="dropdown-item" (click)="editUser(userProfileEditModal)">
                      <i class="material-icons mi-inline mr-2">account_circle</i>
                      <span>{{ '$my_account$' | translate }}</span>
                    </a>
                    @if (isGlobalAdmin || isAgentAdmin) {
                      <a
                        ngbDropdownItem
                        class="dropdown-item"
                        routerLinkActive="active"
                        [routerLink]="['/admin', authService.companyUrlName]"
                        [routerLinkActiveOptions]="{ exact: true }">
                        <i class="material-icons mi-inline mr-2">settings_applications</i>
                        <span>{{ '$menu_admin$' | translate }}</span>
                      </a>
                    }
                    <a
                      ngbDropdownItem
                      class="dropdown-item"
                      routerLinkActive="active"
                      [routerLink]="['/company', authService.companyUrlName, 'calendar']"
                      [routerLinkActiveOptions]="{ exact: true }">
                      <i class="material-icons mi-inline mr-2">event</i>
                      <span>{{ '$menu_calendar$' | translate }}</span>
                    </a>
                    @if (authService.hasModuleInitiations) {
                      <a ngbDropdownItem class="dropdown-item" [routerLink]="`/${authService.companyUrl}/initiations`">
                        <i class="material-icons mi-inline mr-2">bookmark_flag</i>
                        <span>{{ '$menu_initiations$' | translate }}</span>
                      </a>
                    }
                    @if (isAgentAdmin || authService.hasUserRole) {
                      <a
                        ngbDropdownItem
                        class="dropdown-item"
                        [routerLink]="`/${authService.companyUrl}/leads`"
                        [permission]="globals.PERMISSION_SHOW_MENU_LEAD">
                        <i class="material-icons mi-inline mr-2">filter_alt</i>
                        <span>{{ '$menu_leads$' | translate }}</span>
                      </a>
                    }
                    @if (authService.hasModuleResourcePlanning) {
                      <a
                        ngbDropdownItem
                        class="dropdown-item"
                        [routerLink]="['/company', authService.companyUrlName, 'resource-planning']">
                        <i class="material-icons mi-inline mr-2">perm_contact_calendar</i>
                        <span>{{ '$menu_resource_planning$' | translate }}</span>
                      </a>
                    }
                    @if (authService.checkPermission(globals.PERMISSION_DASHBOARD_USER_OVERVIEW_WIDGET)) {
                      <a
                        ngbDropdownItem
                        class="dropdown-item"
                        routerLinkActive="active"
                        [routerLink]="['/company', authService.companyUrlName, 'users']"
                        [routerLinkActiveOptions]="{ exact: true }">
                        <i class="material-icons mi-inline mr-2">person</i>
                        <span>{{ '$menu_users$' | translate }}</span>
                      </a>
                    }
                    @if (authService.checkWarehouseAccessOrLinkedProduct(globals.PERMISSION_SHOW_WAREHOUSE_OVERVIEW)) {
                      <a
                        ngbDropdownItem
                        class="dropdown-item"
                        routerLinkActive="active"
                        [routerLink]="['/company', authService.companyUrlName, 'warehouse', 'overview']"
                        [routerLinkActiveOptions]="{ exact: true }">
                        <i class="material-icons mi-inline mr-2">warehouse</i>
                        <span>{{ '$menu_warehouse_overview$' | translate }}</span>
                      </a>
                    }
                    @if (authService.hasModuleWarehouse) {
                      <a
                        ngbDropdownItem
                        class="dropdown-item"
                        [permission]="globals.PERMISSION_SHOW_WAREHOUSE_DASHBOARD"
                        [routerLink]="['/company', authService.companyUrlName, 'warehouse', 'containers']">
                        <i class="material-icons mi-inline mr-2">pallet</i>
                        <span>{{ '$menu_warehouse_containers$' | translate }}</span>
                      </a>
                    }
                    @if (authService.hasModuleWorkTickets) {
                      <a
                        ngbDropdownItem
                        class="dropdown-item"
                        [routerLink]="['/company', authService.companyUrlName, 'work-tickets']">
                        <i class="material-icons mi-inline mr-2">receipt_long</i>
                        <span>{{ '$menu_work_tickets$' | translate }}</span>
                      </a>
                    }
                    <a
                      ngbDropdownItem
                      class="dropdown-item"
                      href="https://reedge.atlassian.net/servicedesk/customer/portals"
                      target="_blank">
                      <i class="material-icons mi-inline mr-2">headset_mic</i>
                      <span>{{ '$menu_online_support$' | translate }}</span
                      >&nbsp;
                      <i class="material-icons mi-inline mr-2">open_in_new</i>
                    </a>
                    <a ngbDropdownItem class="dropdown-item" href="#" (click)="logout($event)">
                      <i class="material-icons mi-inline mr-2">exit_to_app</i>
                      <span>{{ '$action_logout$' | translate }}</span>
                    </a>
                    <hr />
                    <div
                      class="mt-2 text-dark-blue cursor-pointer font-14 text-center"
                      (click)="userMenu.close(); getChangeLog()">
                      @if (version !== apiVersion) {
                        {{ version }}/{{ apiVersion }}
                      } @else {
                        {{ version }}
                      }
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          }
          <!--Notification End-->
          @if (!authService.loggedIn) {
            <div class="right-nav-wrap flex-shrink-1" style="margin-right: -16px">
              <ul class="navbar-nav ml-auto">
                <li>
                  <a (click)="authService.login()">
                    <i class="material-icons mi-inline mr-2"></i>{{ '$action_login$' | translate }}
                  </a>
                </li>
              </ul>
            </div>
          }
        </div>
      </div>
    </nav>
  }

  @if (selectedAssignment) {
    <div class="secondary-nav w-100">
      <div class="secondary-nav-contents clearfix" [ngClass]="navColor">
        <ul class="nav menu-group menu-group-1">
          <li class="nav-item dropdown nav-item-highlighted">
            <app-assignment-participants-section
              [selectedCustomer]="selectedCustomer"
              [selectedBookingAgent]="selectedBookingAgent"
              [selectedAccount]="selectedAccount" />
          </li>
          @if (showSecondary) {
            @if (selectedAssignment) {
              <li class="nav-item dropdown">
                <a
                  class="nav-link no-caret cursor-default d-flex flex-column justify-content-center"
                  id="locations-dropdown-trigger"
                  role="button">
                  <span class="assignment-info">
                    <app-assignment-name [assignment]="selectedAssignment" />
                  </span>
                  <span class="assignment-info">{{ selectedAssignment.friendlyNumber }}</span>
                  <span class="assignment-info">{{ selectedAssignment.assignmentTemplateName }}</span>
                </a>
              </li>
            }
          }
        </ul>
        @if (showSecondary && selectedAssignment) {
          @if (showTabs) {
            <ul class="nav menu-group menu-group-2 bg-lavender ml-2 custom-menu-group">
              <li class="nav-item d-none d-md-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id]"
                  [routerLinkActiveOptions]="{ exact: true }"
                  >{{ '$menu_overview$' | translate }}</a
                >
              </li>
              @if (authService.hasModuleWarehouse || selectedAssignment.hasLinkedProduct) {
                <li class="nav-item d-none d-lg-block">
                  <a
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'inventory']"
                    >{{ '$menu_inventorylink$' | translate }}</a
                  >
                </li>
              }
              <li class="nav-item d-none d-lg-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'volume']"
                  [class.active]="router.url.includes('volume')"
                  >{{ '$menu_volume$' | translate }}</a
                >
              </li>
              <li class="nav-item d-none d-lg-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'survey']"
                  [class.active]="router.url.includes('survey')"
                  >{{ '$menu_survey$' | translate }}</a
                >
              </li>
              <li class="nav-item d-none d-xl-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'services']"
                  >{{ '$menu_services$' | translate }}</a
                >
              </li>
              @if (authService.hasModuleWorkTickets) {
                <li class="nav-item d-none d-xl-block">
                  <a
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'work-tickets']"
                    >{{ '$menu_work_tickets$' | translate }}</a
                  >
                </li>
              }
              @if (authService.hasModulePurchaseOrders) {
                <li class="nav-item d-none d-xxl-block">
                  <a
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'purchase-orders']"
                    >{{ '$menu_purchase_orders$' | translate }}</a
                  >
                </li>
              }
              <li class="nav-item d-none d-xxl-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'finance']"
                  [class.active]="
                    router.url.includes('finance') || router.url.includes('quotation') || router.url.includes('/order')
                  "
                  >{{ '$menu_finances$' | translate }}</a
                >
              </li>
              <li class="nav-item d-none d-xxxl-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'family']"
                  >{{ '$menu_family$' | translate }}</a
                >
              </li>
              <li class="nav-item d-none d-xxxl-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'activity']"
                  >{{ '$menu_activity$' | translate }}</a
                >
              </li>
              <li class="nav-item d-none d-xxxl-block">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'documents']"
                  >{{ '$menu_documents$' | translate }}</a
                >
              </li>
              <li class="nav-item d-none">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'contacts']"
                  >{{ '$menu_contact$' | translate }}</a
                >
              </li>
              @if (assignmentHasOrders) {
                <li class="nav-item d-none">
                  <a
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'scheduler']"
                    >{{ '$menu_scheduler$' | translate }}</a
                  >
                </li>
              }
              <li
                ngbDropdown
                #moreMenu="ngbDropdown"
                placement="bottom-end top-end"
                class="nav-item dropdown d-none d-md-block">
                <a
                  aria-haspopup="true"
                  ngbDropdownToggle
                  appKeyboardClickable
                  class="nav-link dropdown-toggle no-caret cursor-pointer"
                  id="more-menu-dropdown-trigger"
                  role="button"
                  [class.active]="router.url.includes('documents') || router.url.includes('planning')">
                  <i class="material-icons mi-inline xs-more-info">more_horiz</i>
                  <span class="xs-more-info">{{ '$more$' | translate }}</span>
                </a>
                <div
                  ngbDropdownMenu
                  id="more-menu-dropdown"
                  class="dropdown-menu shadow bg-lavender dropdown-menu-right overflow-hidden"
                  aria-labelledby="more-menu-dropdown-trigger"
                  (click)="moreMenu.close()">
                  @if (authService.hasModuleWarehouse || selectedAssignment.hasLinkedProduct) {
                    <a
                      class="nav-link d-lg-none"
                      routerLinkActive="active"
                      [routerLink]="['assignment', selectedAssignment?.id, 'inventory']"
                      >{{ '$menu_inventorylink$' | translate }}</a
                    >
                  }
                  <a
                    class="nav-link d-lg-none"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'volume']"
                    [class.active]="router.url.includes('volume')"
                    >{{ '$menu_volume$' | translate }}</a
                  >
                  <a
                    class="nav-link d-lg-none"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'survey']"
                    [class.active]="router.url.includes('survey')"
                    >{{ '$menu_survey$' | translate }}</a
                  >
                  <a
                    class="nav-link d-xl-none"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'services']"
                    >{{ '$menu_services$' | translate }}</a
                  >
                  @if (authService.hasModuleWorkTickets) {
                    <a
                      class="nav-link d-xl-none"
                      routerLinkActive="active"
                      [routerLink]="['assignment', selectedAssignment?.id, 'work-tickets']"
                      >{{ '$menu_work_tickets$' | translate }}</a
                    >
                  }
                  @if (authService.hasModulePurchaseOrders) {
                    <a
                      class="nav-link d-xxl-none"
                      routerLinkActive="active"
                      [routerLink]="['assignment', selectedAssignment?.id, 'purchase-orders']"
                      >{{ '$menu_purchase_orders$' | translate }}</a
                    >
                  }
                  <a
                    class="nav-link d-xxl-none"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'finance']"
                    [class.active]="
                      router.url.includes('finance') ||
                      router.url.includes('quotation') ||
                      router.url.includes('/order')
                    "
                    >{{ '$menu_finances$' | translate }}</a
                  >
                  <a
                    class="nav-link d-xxxl-none"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'family']"
                    >{{ '$menu_family$' | translate }}</a
                  >
                  <a
                    class="nav-link d-xxxl-none"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'activity']"
                    >{{ '$menu_activity$' | translate }}</a
                  >
                  <a
                    class="nav-link d-xxxl-none"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'documents']"
                    >{{ '$menu_documents$' | translate }}</a
                  >
                  <a
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'contacts']"
                    >{{ '$menu_contact$' | translate }}</a
                  >
                  @if (assignmentHasOrders) {
                    <a
                      class="nav-link"
                      routerLinkActive="active"
                      [routerLink]="['assignment', selectedAssignment?.id, 'scheduler']"
                      >{{ '$menu_scheduler$' | translate }}</a
                    >
                  }
                </div>
              </li>
            </ul>
          }
          <!-- 'more' dropdown button & menu in tiny screens -->
          <div ngbDropdown class="dropdown xs-more-dropdown d-block d-md-none">
            <button aria-haspopup="true" ngbDropdownToggle class="btn dropdown-toggle xs-more-btn" type="button">
              <i class="material-icons mi-inline">more_horiz</i> {{ '$more$' | translate }}
            </button>
            <ul ngbDropdownMenu class="dropdown-menu bg-lavender">
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id]"
                  [routerLinkActiveOptions]="{ exact: true }"
                  >{{ '$menu_overview$' | translate }}</a
                >
              </li>
              @if (authService.hasModuleWarehouse || selectedAssignment.hasLinkedProduct) {
                <li>
                  <a
                    ngbDropdownItem
                    class="dropdown-item"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'inventory']"
                    >{{ '$menu_inventorylink$' | translate }}</a
                  >
                </li>
              }
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'volume']"
                  [class.active]="router.url.includes('volume')"
                  >{{ '$menu_volume$' | translate }}</a
                >
              </li>
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'survey']"
                  [class.active]="router.url.includes('survey')"
                  >{{ '$menu_survey$' | translate }}</a
                >
              </li>
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'services']"
                  >{{ '$menu_services$' | translate }}</a
                >
              </li>
              @if (authService.hasModuleWorkTickets) {
                <li>
                  <a
                    ngbDropdownItem
                    class="dropdown-item"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'work-tickets']"
                    >{{ '$menu_work_tickets$' | translate }}</a
                  >
                </li>
              }
              @if (authService.hasModulePurchaseOrders) {
                <li>
                  <a
                    ngbDropdownItem
                    class="dropdown-item"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'purchase-orders']"
                    >{{ '$menu_purchase_orders$' | translate }}</a
                  >
                </li>
              }
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'finance']"
                  [class.active]="
                    router.url.includes('finance') || router.url.includes('quotation') || router.url.includes('/order')
                  "
                  >{{ '$menu_finances$' | translate }}</a
                >
              </li>
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'family']"
                  >{{ '$menu_family$' | translate }}</a
                >
              </li>
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'activity']"
                  >{{ '$menu_activity$' | translate }}</a
                >
              </li>
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'documents']"
                  >{{ '$menu_documents$' | translate }}</a
                >
              </li>
              <li>
                <a
                  ngbDropdownItem
                  class="dropdown-item"
                  routerLinkActive="active"
                  [routerLink]="['assignment', selectedAssignment?.id, 'contacts']"
                  >{{ '$menu_contact$' | translate }}</a
                >
              </li>
              @if (assignmentHasOrders) {
                <li>
                  <a
                    ngbDropdownItem
                    class="dropdown-item"
                    routerLinkActive="active"
                    [routerLink]="['assignment', selectedAssignment?.id, 'scheduler']"
                    >{{ '$menu_scheduler$' | translate }}</a
                  >
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  } @else if (isResourcePlanningRoute) {
    <app-resource-planning-nav-bar />
  }
</div>

@if (changeLog) {
  <p-dialog
    modal="true"
    [closable]="false"
    [header]="changeLog.version"
    [style]="{ width: '50vw' }"
    [(visible)]="displayNewVersionInfo"
    (onHide)="hideNewVersionModal()">
    <hr />
    <span [innerHTML]="changeLog.description"></span>
    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-end">
        <button class="btn btn-capsule btn-primary" (click)="hideNewVersionModal()">{{ '$close$' | translate }}</button>
      </div>
    </ng-template>
  </p-dialog>
}

<ng-template #userProfileEditModal let-modal>
  <app-user-profile-edit [modal]="modal" [userId]="userId()" />
</ng-template>
